<template>
    <div class="home">
        <!-- 轮播图 -->
        <section class="banner">
            <div class="banner-slider">
                <div class="banner-item active">
                    <div class="banner-content">
                        <h1>新能源二次设备安装及调试专家</h1>
                        <p>专注于为新能源行业提供专业的二次设备安装、调试及技术支持服务</p>
                        <button @click="$router.push('/services')">了解更多</button>
                    </div>
                    <div class="banner-bg" style="background-image: url('https://pic.rmb.bdstatic.com/bjh/3f1164d3149c/250320/d781d48a4fea4ce7c504f20e0b6b799a.jpeg');"></div>
                </div>
            </div>
        </section>

        <!-- 新闻轮播 -->
        <NewsCarousel />

        <!-- 公司简介 -->
        <section class="about-section">
            <div class="container">
                <div class="section-header">
                    <h2>关于我们</h2>
                </div>

                <div class="about-content">
                    <div class="about-img">
                        <img src="https://0406-lhf.oss-cn-chengdu.aliyuncs.com/company.png" alt="四川博乐科技有限公司办公环境">
                    </div>
                    <div class="about-text">
                        <h3>{{ companyInfo.companyName || '四川庚源电力科技有限公司' }}</h3>
                        <p>{{ companyInfo.introduction || '四川庚源电力科技有限公司，是一家致力于成为行业领先的电力通信自动化、二次安防系统和信息安全等解决方案的系统集成商，同时紧跟国家能源发展战略，提供风电和光伏电站的运维服务，为“碳中和、碳达峰”贡献力量。公司始终坚持走“创新”之路，用好的产品来更好地服务于客户。公司目前总人数20人，其中本科以上8人，高级职称3人。公司主要经营：电力技术开发、技术咨询、技术服务和推广；计算机网络工程、通信工程、建筑装饰装修工程、机电设备安装工程、电力工程、安防工程、电子与智能化工程的设计与施工，机械设备、仪器仪表、安防设备、办公用品的销售、技术服务。公司现与国内外知名企业公司深度合作，并取得3M电力电缆附件、电气绝缘及维护产品特约经销商及东软NetEye钻石级合作伙伴。公司拥有雄厚的资金基础、深耕技术的专业团队、具有先进创新理念的运营团队和技术实力过硬的工程技术人员。公司倡导团队协作，公平公正，强调员工与企业共成长的企业文化，鼓励创新，致力于为员工营造充分展示自我才智、发挥潜能的舞台。' }}</p>
                        <p>公司已取得电子与智能化专业承包贰级、承装（修、试）电力设施许可证四级资质及安全生产许可证；已通过ISO27001信息安全管理体系、ISO9001质量管理体系、ISO14001环境管理体系、ISO45001职业健康安全管理体系等认证。始终坚持“高质、高效”的服务理念，始终把产品质量、技术服务放在首位，以优质服务为客户创造更好的价值。</p>
                        <div class="about-stats">
                            <div class="stat-item">
                                <span class="stat-number">5+</span>
                                <span class="stat-text">年行业经验</span>
                            </div>
                            <div class="stat-item">
                                <span class="stat-number">110+</span>
                                <span class="stat-text">成功案例</span>
                            </div>
                            <div class="stat-item">
                                <span class="stat-number">20+</span>
                                <span class="stat-text">知名合作伙伴</span>
                            </div>
                        </div>
                        <button @click="$router.push('/about')">查看详情</button>
                    </div>
                </div>
            </div>
        </section>

        <!-- 业务范围 -->
        <section class="services-section">
            <div class="container">
                <div class="section-header">
                    <h2>业务范围</h2>
                </div>

                <div class="services-grid">
                    <div class="service-card" @click="$router.push('/services')">
                        <div class="service-icon">
                            <i class="fa fa-cogs"></i>
                        </div>
                        <h3>二次设备安装</h3>
                        <p>专业的新能源电站二次设备安装服务，包括保护装置、测控装置、自动化系统等设备的安装与接线。</p>
                    </div>

                    <div class="service-card" @click="$router.push('/services')">
                        <div class="service-icon">
                            <i class="fa fa-sliders"></i>
                        </div>
                        <h3>设备调试</h3>
                        <p>精准的设备调试服务，确保保护定值正确、逻辑关系无误、通信正常，保障设备安全稳定运行。</p>
                    </div>

                    <div class="service-card" @click="$router.push('/services')">
                        <div class="service-icon">
                            <i class="fa fa-wrench"></i>
                        </div>
                        <h3>技术支持</h3>
                        <p>提供专业的技术咨询与支持，解决设备运行过程中遇到的各种技术问题，保障电站稳定运行。</p>
                    </div>

                    <div class="service-card" @click="$router.push('/services')">
                        <div class="service-icon">
                            <i class="fa fa-line-chart"></i>
                        </div>
                        <h3>系统集成</h3>
                        <p>新能源电站自动化系统集成服务，实现数据采集、监控、控制等功能的一体化解决方案。</p>
                    </div>
                    <div class="service-card" @click="$router.push('/services')">
                        <div class="service-icon">
                            <i class="fa fa-wrench"></i>
                        </div>
                        <h3>3M电缆头制作</h3>
                        <p>提供专业的3M冷缩套管、中间头、电缆头及附件现场安服务。</p>
                    </div>
                    <div class="service-card" @click="$router.push('/services')">
                        <div class="service-icon">
                            <i class="fa fa-sliders"></i>
                        </div>
                        <h3>一次试验</h3>
                        <p>提供针对单个设备、系统、或厂站年检、交接试验等</p>
                    </div>
                </div>
            </div>
        </section>

        <!-- 合作伙伴 -->
        <section class="partners-section">
            <div class="container">
                <div class="section-header">
                    <h2>合作伙伴</h2>
                    <p>与行业内知名企业保持密切合作关系，共同推动新能源行业发展</p>
                </div>

                <div class="partners-grid">
                    <div class="partner-item" v-for="partner in partners" :key="partner.id">
                        <div class="partner-logo">
                            <img :src="partner.logoUrl || `https://picsum.photos/id/${200+partner.id}/200/100`" :alt="partner.name">
                        </div>
                        <h3>{{ partner.name }}</h3>
                        <p>{{ partner.description }}</p>
                    </div>
                </div>

                <div class="view-more">
                    <button @click="$router.push('/partners')">查看全部</button>
                </div>
            </div>
        </section>

        <!-- 成功案例 -->
        <section class="cases-section">
            <div class="container">
                <div class="section-header">
                    <h2>成功案例</h2>
                    <p>我们完成的部分新能源项目案例展示</p>
                </div>

                <div class="cases-grid">
                    <div class="case-card" v-for="caseItem in cases" :key="caseItem.id" @click="$router.push(`/cases/${caseItem.id}`)">
                        <div class="case-img">
                            <img :src="caseItem.coverImage || `https://picsum.photos/id/${100+caseItem.id}/400/300`" :alt="caseItem.title">
                        </div>
                        <div class="case-info">
                            <h3>{{ caseItem.title }}</h3>
                            <p class="case-client"><i class="fa fa-user"></i> {{ caseItem.client }}</p>
                            <p class="case-location"><i class="fa fa-map-marker"></i> {{ caseItem.projectLocation }}</p>
                            <p class="case-date"><i class="fa fa-calendar"></i> {{ caseItem.completionTime }}</p>
                        </div>
                    </div>
                </div>

                <div class="view-more">
                    <button @click="$router.push('/cases')">查看全部案例</button>
                </div>
            </div>
        </section>

        <!-- 联系我们 -->
        <section class="contact-section">
            <div class="container">
                <div class="section-header">
                    <h2>联系我们</h2>
                    <p>如有任何疑问或需求，请随时与我们联系</p>
                </div>

                <div class="contact-content">
                    <div class="contact-form">
                        <h3>发送消息</h3>
                        <form @submit.prevent="submitMessage">
                            <div class="form-group">
                                <input type="text" v-model="message.name" placeholder="您的姓名" required>
                            </div>
                            <div class="form-group">
                                <input type="tel" v-model="message.phone" placeholder="联系电话" required>
                            </div>
                            <div class="form-group">
                                <input type="email" v-model="message.email" placeholder="电子邮箱">
                            </div>
                            <div class="form-group">
                                <textarea v-model="message.content" placeholder="请输入您的留言内容" rows="4" required></textarea>
                            </div>
                            <button type="submit" class="submit-btn">发送留言</button>
                        </form>
                        <div class="section-header" >
                            <p>您的留言会发送至我们的专员，预计两个工作日内回复，同时</p>
                            <p>我们承诺:您的信息不会被泄露</p>
                        </div>
                    </div>

                    <div class="contact-info">
                        <h3>联系方式</h3>
                        <ul>
                            <li>
                                <i class="fa fa-map-marker"></i>
                                <span>{{ companyInfo.address || '四川省成都市高新区天府大道123号' }}</span>
                            </li>
                            <li>
                                <i class="fa fa-phone"></i>
                                <span>{{ companyInfo.phone || '028-12345678' }}</span>
                            </li>
                            <li>
                                <i class="fa fa-envelope"></i>
                                <span>{{ companyInfo.email || 'info@boletech.com' }}</span>
                            </li>
                            <li>
                                <i class="fa fa-clock-o"></i>
                                <span>周一至周五: 9:00 - 18:00</span>
                            </li>
                        </ul>

                        <div class="map-container">
                            <img src="https://picsum.photos/id/1015/600/400" alt="公司位置地图">
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { companyApi, partnerApi, caseApi, contactApi } from '@/api'
import NewsCarousel from '@/components/NewsCarousel.vue'

export default {
    name: 'HomePage',
    components: {
        NewsCarousel
    },
    data() {
        return {
            companyInfo: {},
            partners: [],
            cases: [],
            message: {
                name: '',
                phone: '',
                email: '',
                content: ''
            }
        }
    },
    mounted() {
        this.getCompanyInfo()
        this.getPartners()
        this.getCases()
    },
    methods: {
        // 获取公司信息
        getCompanyInfo() {
            companyApi.getCompanyInfo().then(res => {
                if (res) {
                    this.companyInfo = res.data
                }
            }).catch(err => {
                console.error('获取公司信息失败:', err)
            })
        },

        // 获取合作伙伴
        getPartners() {
            partnerApi.getAllPartners().then(res => {
                if (res && res.data) {
                    // 只显示前3个合作伙伴
                    this.partners = res.data.slice(0, 3)
                } else {
                    // 添加默认合作伙伴数据
                    this.partners = [
                        {
                            id: 1,
                            name: '合作伙伴1',
                            description: '专业的电力设备供应商',
                            logoUrl: 'https://picsum.photos/id/1/200/100'
                        },
                        {
                            id: 2,
                            name: '合作伙伴2',
                            description: '新能源技术解决方案提供商',
                            logoUrl: 'https://picsum.photos/id/2/200/100'
                        },
                        {
                            id: 3,
                            name: '合作伙伴3',
                            description: '电力工程建设专家',
                            logoUrl: 'https://picsum.photos/id/3/200/100'
                        }
                    ]
                }
            }).catch(err => {
                console.error('获取合作伙伴失败:', err)
                // 添加默认合作伙伴数据
                this.partners = [
                    {
                        id: 1,
                        name: '合作伙伴1',
                        description: '专业的电力设备供应商',
                        logoUrl: 'https://picsum.photos/id/1/200/100'
                    },
                    {
                        id: 2,
                        name: '合作伙伴2',
                        description: '新能源技术解决方案提供商',
                        logoUrl: 'https://picsum.photos/id/2/200/100'
                    },
                    {
                        id: 3,
                        name: '合作伙伴3',
                        description: '电力工程建设专家',
                        logoUrl: 'https://picsum.photos/id/3/200/100'
                    }
                ]
            })
        },

        // 获取案例
        getCases() {
            caseApi.getAllCases().then(res => {
                if (res && res.data) {
                    // 只显示前3个案例
                    this.cases = res.data.slice(0, 3)
                } else {
                    // 添加默认案例数据
                    this.cases = [
                        {
                            id: 1,
                            title: '某风电项目二次设备安装',
                            client: '某新能源公司',
                            projectLocation: '四川省凉山州',
                            completionTime: '2024-06-15',
                            coverImage: 'https://picsum.photos/id/10/400/300'
                        },
                        {
                            id: 2,
                            title: '光伏电站自动化系统集成',
                            client: '某电力集团',
                            projectLocation: '青海省海西州',
                            completionTime: '2024-05-20',
                            coverImage: 'https://picsum.photos/id/11/400/300'
                        },
                        {
                            id: 3,
                            title: '变电站保护装置调试',
                            client: '某电网公司',
                            projectLocation: '四川省成都市',
                            completionTime: '2024-04-10',
                            coverImage: 'https://picsum.photos/id/12/400/300'
                        }
                    ]
                }
            }).catch(err => {
                console.error('获取案例失败:', err)
                // 添加默认案例数据
                this.cases = [
                    {
                        id: 1,
                        title: '某风电项目二次设备安装',
                        client: '某新能源公司',
                        projectLocation: '四川省凉山州',
                        completionTime: '2024-06-15',
                        coverImage: 'https://picsum.photos/id/10/400/300'
                    },
                    {
                        id: 2,
                        title: '光伏电站自动化系统集成',
                        client: '某电力集团',
                        projectLocation: '青海省海西州',
                        completionTime: '2024-05-20',
                        coverImage: 'https://picsum.photos/id/11/400/300'
                    },
                    {
                        id: 3,
                        title: '变电站保护装置调试',
                        client: '某电网公司',
                        projectLocation: '四川省成都市',
                        completionTime: '2024-04-10',
                        coverImage: 'https://picsum.photos/id/12/400/300'
                    }
                ]
            })
        },

        // 提交留言
        submitMessage() {
            contactApi.submitContact(this.message).then(res => {
                if (res) {
                    this.$message.success('留言发送成功，我们会尽快与您联系！')
                    // 清空表单
                    this.message = {
                        name: '',
                        phone: '',
                        email: '',
                        content: ''
                    }
                }
            }).catch(err => {
                console.error('留言发送失败:', err)
                this.$message.error('留言发送失败，请稍后重试')
            })
        }
    }
}
</script>

<style scoped>
/* 轮播图样式 */
.banner {
    position: relative;
    height: 600px;
    overflow: hidden;
}

.banner-item {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: opacity 1s;
}

.banner-item.active {
    opacity: 1;
    z-index: 1;
}

.banner-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    filter: brightness(0.7);
}

.banner-content {
    position: relative;
    z-index: 2;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #fff;
    text-align: center;
    padding: 0 20px;
}

.banner-content h1 {
    font-size: 3rem;
    margin-bottom: 20px;
    max-width: 800px;
}

.banner-content p {
    font-size: 1.2rem;
    margin-bottom: 30px;
    max-width: 600px;
}

.banner-content button {
    padding: 12px 30px;
    background-color: #165DFF;
    color: #fff;
    border: none;
    border-radius: 4px;
    font-size: 1rem;
    cursor: pointer;
    transition: background-color 0.3s;
}

.banner-content button:hover {
    background-color: #0E42D2;
}

/* 通用 section 样式 */
section {
    padding: 80px 0;
}

.container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
}

.section-header {
    text-align: center;
    margin-bottom: 60px;
}

.section-header h2 {
    font-size: 2.2rem;
    color: #2c3e50;
    margin-bottom: 15px;
    position: relative;
    display: inline-block;
    padding-bottom: 10px;
}

.section-header h2::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 3px;
    background-color: #165DFF;
}

.section-header p {
    font-size: 1rem;
    color: #7f8c8d;
    max-width: 700px;
    margin: 0 auto;
}

/* 关于我们样式 */
.about-section {
    background-color: #f9f9f9;
}

.about-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 40px;
    align-items: center;
}

.about-img img {
    width: 100%;
    border-radius: 8px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.about-text h3 {
    font-size: 1.8rem;
    color: #2c3e50;
    margin-bottom: 20px;
}

.about-text p {
    font-size: 1rem;
    line-height: 1.8;
    color: #555;
    margin-bottom: 20px;
}

.about-stats {
    display: flex;
    gap: 30px;
    margin: 30px 0;
}

.stat-item {
    text-align: center;
}

.stat-number {
    display: block;
    font-size: 2rem;
    font-weight: bold;
    color: #165DFF;
    margin-bottom: 5px;
}

.stat-text {
    color: #7f8c8d;
    font-size: 0.9rem;
}

.about-text button,
.view-more button {
    padding: 10px 25px;
    background-color: #165DFF;
    color: #fff;
    border: none;
    border-radius: 4px;
    font-size: 1rem;
    cursor: pointer;
    transition: all 0.3s;
}

.about-text button:hover,
.view-more button:hover {
    background-color: #0E42D2;
    transform: translateY(-2px);
}

/* 业务范围样式 */
.services-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 30px;
}

.service-card {
    background-color: #fff;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
    transition: all 0.3s;
    cursor: pointer;
}

.service-card:hover {
    transform: translateY(-10px);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}

.service-icon {
    width: 60px;
    height: 60px;
    background-color: #f0f5ff;
    color: #165DFF;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    font-size: 1.5rem;
}

.service-card h3 {
    font-size: 1.3rem;
    color: #2c3e50;
    margin-bottom: 15px;
}

.service-card p {
    color: #7f8c8d;
    line-height: 1.6;
}

/* 合作伙伴样式 */
.partners-section {
    background-color: #f9f9f9;
}

.partners-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 30px;
}

.partner-item {
    background-color: #e5e2e2;
    padding: 30px;
    border-radius: 8px;
    text-align: center;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
}

.partner-logo {
    max-width: 200px;
    height: 100px;
    margin: 0 auto 20px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.partner-logo img {
    max-width: 100%;
    max-height: 80px;
    object-fit: contain;
}

.partner-item h3 {
    font-size: 1.2rem;
    color: #2c3e50;
    margin-bottom: 15px;
}

.partner-item p {
    color: #7f8c8d;
    line-height: 1.6;
}

/* 案例样式 */
.cases-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 30px;
}

.case-card {
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
    transition: all 0.3s;
    cursor: pointer;
}

.case-card:hover {
    transform: translateY(-10px);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}

.case-img {
    height: 200px;
    overflow: hidden;
}

.case-img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s;
}

.case-card:hover .case-img img {
    transform: scale(1.05);
}

.case-info {
    padding: 20px;
}

.case-info h3 {
    font-size: 1.2rem;
    color: #2c3e50;
    margin-bottom: 15px;
}

.case-client,
.case-location,
.case-date {
    font-size: 0.9rem;
    color: #7f8c8d;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
}

.case-client i,
.case-location i,
.case-date i {
    margin-right: 8px;
    color: #165DFF;
}

.view-more {
    text-align: center;
    margin-top: 40px;
}

/* 联系我们样式 */
.contact-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 40px;
}

.contact-form h3,
.contact-info h3 {
    font-size: 1.5rem;
    color: #2c3e50;
    margin-bottom: 25px;
    position: relative;
    padding-bottom: 10px;
}

.contact-form h3::after,
.contact-info h3::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 50px;
    height: 2px;
    background-color: #165DFF;
}

.form-group {
    margin-bottom: 20px;
}

.form-group input,
.form-group textarea {
    width: 100%;
    padding: 12px 15px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 1rem;
    transition: border-color 0.3s;
}

.form-group input:focus,
.form-group textarea:focus {
    outline: none;
    border-color: #165DFF;
}

.submit-btn {
    width: 100%;
    padding: 12px;
    background-color: #165DFF;
    color: #fff;
    border: none;
    border-radius: 4px;
    font-size: 1rem;
    cursor: pointer;
    transition: background-color 0.3s;
}

.submit-btn:hover {
    background-color: #0E42D2;
}

.contact-info ul {
    list-style: none;
    padding: 0;
    margin: 0 0 30px 0;
}

.contact-info li {
    margin-bottom: 20px;
    display: flex;
    align-items: flex-start;
}

.contact-info i {
    width: 30px;
    height: 30px;
    background-color: #f0f5ff;
    color: #165DFF;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
    flex-shrink: 0;
}

.contact-info span {
    color: #555;
    line-height: 1.6;
}

.map-container {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.map-container img {
    width: 100%;
    height: 250px;
    object-fit: cover;
}

/* 响应式样式 */
@media (max-width: 992px) {
    .banner-content h1 {
        font-size: 2.5rem;
    }

    .about-content,
    .contact-content {
        grid-template-columns: 1fr;
    }

    .about-img {
        order: 1;
    }

    .about-text {
        order: 2;
    }
}

@media (max-width: 768px) {
    .banner {
        height: 500px;
    }

    .banner-content h1 {
        font-size: 2rem;
    }

    .banner-content p {
        font-size: 1rem;
    }

    .section-header h2 {
        font-size: 1.8rem;
    }

    .about-stats {
        flex-direction: column;
        gap: 15px;
    }
}

@media (max-width: 576px) {
    .banner {
        height: 400px;
    }

    .banner-content h1 {
        font-size: 1.5rem;
    }

    section {
        padding: 50px 0;
    }

    .cases-grid {
        grid-template-columns: 1fr;
    }
}
</style>
